import { logout } from "../app/Login/logout";
import { getConfig } from "../config";

// Helper to safely get base URL at runtime
function getBaseUrl(): string {
  try {
    const { BOAT_SERVICE_URL } = getConfig();
    return BOAT_SERVICE_URL;
  } catch (err) {
    console.error("Config not loaded yet", err);
    return ""; // fallback or throw error if preferred
  }
}

const originalFetch = window.fetch;

export class FetchError extends Error {
  constructor(
    public status: number,
    public message: string,
    public context?: any,
  ) {
    super(message);
  }
}

export const boatsFetch = async <T>(
  url: string,
  method: "GET" | "POST" | "PATCH" | "PUT" = "GET",
  body?: any,
  signal?: AbortSignal,
) => {
  const baseUrl = getBaseUrl();
  const input = `${baseUrl}${url}`;

  const response = await originalFetch(input, {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    signal,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json();

  if (response.status === 401) {
    logout();
  }

  if (response.status >= 400) {
    throw new FetchError(response.status, `Failed to fetch ${method} @ ${url}`, data);
  }

  return data as T;
};
